import { gql } from '@apollo/client';

export const postComercioPactar = gql`
mutation  comercioPactarSPApiRQ{
    ComercioPactarSPApiRQ(input: $input,method:$method)  
        @rest(type: "comercioPactarSPApiRS", path: "/api/gateway/formularios/PactarComercio", method: $method){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`